export enum DirectionOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const parseOrder = (order?: string) => {
    if (order === 'ascend') return DirectionOrder.ASC;
    if (order === 'descend') return DirectionOrder.DESC;
    return undefined;
};
